import { ElementState, Preview } from "@creatomate/preview";

import { Organization, Story, Template, TemplateType } from "chq";

import getDefaultSource from "./getDefaultSource";
import { genericImageTemplate, genericVideoTemplate } from "../../sidebar/tabs/template/implementors/implementors";

export interface ImplementorTemplateParams {
  template: Template;
  preview: Preview;
  mediaElements: ElementState[];
  defaultVideoProperties: Record<string, any>;
  organization: Organization;
  story?: Story;
  localfile?: File | { urls: any; alt_description: string };
}

const defaultVideoProperties = {
  x: "50%",
  y: "50%",
  height: "100%",
  border_radius: 0,
  clip: false
};

const templateFunctions: { [key: string]: (params: ImplementorTemplateParams) => Promise<void> } = {
  video: genericVideoTemplate,
  image: genericImageTemplate
};

const setCustomTemplate = async (
  type: TemplateType,
  template: Template,
  preview: Preview,
  organization: Organization,
  story: Story,
  mediaElements: ElementState[] = []
): Promise<void> => {
  const templateFunction = templateFunctions[type];
  if (templateFunction) {
    await templateFunction({
      template, preview, mediaElements, defaultVideoProperties, organization, story
    });
  } else {
    await preview.setSource(await getDefaultSource({ organization, preview }));
  }
};

export default setCustomTemplate;
